import { FC } from 'react';
import { useHistory } from 'react-router';
import { Box, Image, VStack } from '@chakra-ui/react';

import { TeamMembersRequestStatus } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';
import { getCardRequestAssetSrc } from 'common/paymentCards/utils';
import SunshineTag from 'components/_core/SunshineTag';
import Text from 'components/_core/Text';
import CancelTeamMemberRequestSidebar, {
  CancelTeamMemberRequestSidebarProps,
} from 'components/CancelTeamMemberRequestSidebar';

import { OngoingPaymentCardRequest } from '../../../../hooks/useOngoingPaymentCardsRequests';
import { OngoingPaymentCardsRequestsDocument } from '../../../../hooks/useOngoingPaymentCardsRequests/ongoingPaymentCardsRequests.gql';
import * as cardsRoutes from '../../../../routes';
import locales from './locales';

interface OngoingRequestSidebarProps {
  request: OngoingPaymentCardRequest;
}

const OngoingRequestSidebar: FC<OngoingRequestSidebarProps> = ({ request }) => {
  const { companyProfileId } = useCompanyContext();
  const history = useHistory();
  const handleOnCompleted: CancelTeamMemberRequestSidebarProps['onCompleted'] =
    () => {
      history.push(cardsRoutes.root);
    };

  const imageAsset = getCardRequestAssetSrc(request);

  return (
    <CancelTeamMemberRequestSidebar
      canCancelRequest={request.status === TeamMembersRequestStatus.Pending}
      closeTo={cardsRoutes.root}
      onCompleted={handleOnCompleted}
      refetchQueries={[
        {
          query: OngoingPaymentCardsRequestsDocument,
          variables: { companyProfileId: companyProfileId ?? '' },
        },
      ]}
      requestId={request.teamMembersRequestId}
      variant="ghost"
    >
      <CancelTeamMemberRequestSidebar.Header />
      <CancelTeamMemberRequestSidebar.Body gap="space-32">
        <Box height="168px" marginX="auto" position="relative" width="264px">
          <SunshineTag
            colorScheme="blue"
            left="space-16"
            position="absolute"
            size="sm"
            top="space-16"
          >
            {locales.badgeLabel}
          </SunshineTag>
          <Image
            alt=""
            height="100%"
            role="presentation"
            src={imageAsset}
            width="100%"
          />
        </Box>
        <VStack alignItems="flex-start" spacing="space-4">
          <Text fontWeight="weight-500" variant="primary">
            {locales.headline}
          </Text>
          <Text>{locales.subtitle}</Text>
        </VStack>
      </CancelTeamMemberRequestSidebar.Body>
    </CancelTeamMemberRequestSidebar>
  );
};

export default OngoingRequestSidebar;
